import { createContext } from 'react';

export interface AppContextType {
  platform: string;
  questionnaireAnswers: Record<string, any>;
  updateAnswer: (questionId: string, answer: any) => void;
  token: string | null;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);
